<div class="row h-100">
  <div class="col-md-6 super-compos-left-shadow">
    <i-title [text]="'docToValidate.validateDocument' | translate"></i-title>
    <i-table
      [paginator]="true"
      class="super-table"
      [columns]="columns"
      [items]="files"
      (onClickRow)="openFile($event)"
      id="documenttovalidates"
      [forselectionDefaultOption]="false"
      [search]="true"
      [forselection]="forselection"
      [multiselect]="true"
      [paginator]="true"
      [height]="'calc(100vh - 150px)'"
      [menu]="menuSelection"></i-table>
  </div>
  @if (!fileToShow) {
    <div class="col-md-6 viewerFull d-flex align-items-center justify-content-center">
      <img src="./assets/img/decoration/nofiles.svg " class="img-fluid" width="600" alt="" />
    </div>
  }
  @if (fileToShow) {
    <div class="col-md-6 viewerFull mt-4">
      <div class="d-flex align-items-center justify-content-center mb-4">
        <i-button styleClass="blue me-2" text="Voir la fiche courrier liée #{{ fileToShow.mailId }}" (click)="goTo(fileToShow.mailId)"></i-button>
      </div>
      <app-courrier-file-viewer [currentFiles]="fileToShow" class="d-block font-source"></app-courrier-file-viewer>
    </div>
  }
</div>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="showValidateModal"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'docToValidate.acceptValidation' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3" [formGroup]="formAccept">
    <div class="col-md-12 mb-2">
      <label class="super-compos-label-input">{{ 'dashboard.comment' | translate }}</label>
      <textarea
        rows="5"
        cols="30"
        [placeholder]="'docToValidate.insertComment' | translate"
        formControlName="justification"
        class="super-compos-input-text form-control w-100"
        pInputTextarea></textarea>
    </div>
  </div>
  <i-button styleClass="bottomButton red mb-3" (click)="showValidateModal = false" [text]="'cancel' | translate"></i-button>
  <i-button styleClass="bottomButton green" (click)="validate()" [text]="'confirm' | translate"></i-button>
</p-dialog>

<p-dialog
  styleClass="super-compos-modal-content modal-scss"
  [(visible)]="refuseModal"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '60vw' }"
  [closable]="true">
  <p-header>
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="modal-title personalized-modal-title-iCourrier">{{ 'docToValidate.rejectValidation' | translate }}</h5>
    </div>
  </p-header>
  <div class="row mb-3" [formGroup]="formModal" #questionModal>
    <div formArrayName="files" class="col-md-12">
      <i-accordion>
        @for (file of filess.controls; track file; let i = $index) {
          <i-accordion-tab [selected]="i === 0" header="{{ file.get('name').value }}" class="mb-3" [showEditBtn]="false">
            <i-title text="Choix de l'étape" level="2"></i-title>
            <div [formGroupName]="i">
              @if (refuseItems && refuseItems[i].previousStep?.length > 0) {
                <i-table
                  [paginator]="true"
                  (onClickRow)="select($event, i)"
                  class="super-table"
                  [columns]="columnsRefuse"
                  [items]="refuseItems[i].previousStep"
                  id="refusePreviousStep"
                  [multiselect]="false"
                  [search]="true">
                </i-table>
              }
              @if (file.get('previousStepName').value) {
                <div class="alert alert-primary mb-2">{{ 'courrierFiche.selectedStep' | translate }} : {{ file.get('previousStepName').value }}</div>
              }
              @if (refuseItems && refuseItems[i].previousStep?.length > 0 && refuseItems[i]?.contacts?.length > 0) {
                <div class="col-md-12 mb-2">
                  <label class="super-compos-label-input"
                    >{{ 'courrierFiche.managerChoice' | translate }}
                    @if (file.get('contactId').errors?.required === true) {
                      <span> *</span>
                    }
                  </label>
                  <p-dropdown
                    styleClass="w-100"
                    [options]="refuseItems[i]?.contacts"
                    [placeholder]="'courrierFiche.selectManager' | translate"
                    [showClear]="true"
                    formControlName="contactId"
                    appendTo="body"
                    [virtualScroll]="true"
                    [filter]="true"
                    virtualScrollItemSize="30">
                  </p-dropdown>
                </div>
              }
              <div class="col-md-12 mb-2">
                <label class="super-compos-label-input">{{ 'comment' | translate }}</label>
                <textarea
                  rows="5"
                  cols="30"
                  [placeholder]="'docToValidate.insertComment' | translate"
                  formControlName="justification"
                  class="super-compos-input-text form-control w-100"
                  pInputTextarea></textarea>
              </div>
            </div>
          </i-accordion-tab>
        }
      </i-accordion>
    </div>
  </div>
  <i-button styleClass="bottomButton red mb-3" (click)="refuseModal = false" [text]="'cancel' | translate"></i-button>
  <i-button styleClass="bottomButton green" [disabled]="formDisabled" (click)="submitRefuse()" text="Confirmer"></i-button>
</p-dialog>

<p-confirmDialog
  key="remplacantDocumentToValidate"
  #cd
  appendTo="body"
  styleClass="super-compos-modal-content confirmModal"
  [header]="'docToValidate.confirmation' | translate"
  icon="bi bi-exclamation-triangle"
  baseZIndex="1000">
  <p-footer>
    <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
    <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>
